import React, { lazy, Suspense, useMemo } from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import LoadingBackgroundPage from 'src/components/LoadingBackgroundPage/LoadingBackgroundPage'
import StaticPage from 'src/components/StaticPage/StaticPage'
import {
  selectAppName,
  selectBrandName,
  selectExternalPrivacyUrl,
} from 'src/redux/selectors/session.selectors'

const Privacy: React.FC = () => {
  const brandName = useSelector(selectBrandName)
  const externalPrivacyUrl = useSelector(selectExternalPrivacyUrl)
  const appName = useSelector(selectAppName)

  const PrivacyComponent = useMemo(
    () =>
      externalPrivacyUrl === undefined
        ? lazy(() => import(`src/branded/${brandName}/Privacy/Privacy`))
        : (): null => {
            window.location.href = externalPrivacyUrl
            return null
          },
    [brandName],
  )

  return (
    <StaticPage>
      <Helmet>
        <title>{`Privacy Policy for ${appName}`}</title>
        <meta
          name="description"
          content={`This Privacy Policy explains how ${appName} and its partner collect, use and disclose information you provide to us or which we otherwise collect.`}
        />
      </Helmet>
      <Suspense fallback={<LoadingBackgroundPage />}>
        <PrivacyComponent />
      </Suspense>
    </StaticPage>
  )
}

export default Privacy
